"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNode = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const SelfContext_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/SelfContext"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DotIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DotIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const getQuestionAncestors_1 = require("../helpers/getQuestionAncestors");
const QuestionTreeList_1 = __importDefault(require("./QuestionTreeList"));
const QuestionTreeNodeBox_1 = __importDefault(require("./QuestionTreeNodeBox"));
const QuestionTreeNodeButtons_1 = __importDefault(require("./QuestionTreeNodeButtons"));
const QuestionTreeNodeExpander_1 = __importDefault(require("./QuestionTreeNodeExpander"));
const QuestionTreeNodeTitle_1 = __importDefault(require("./QuestionTreeNodeTitle"));
const QuestionTreeNodeType_1 = __importDefault(require("./QuestionTreeNodeType"));
const makeMyClasses = () => ({
    root: {
        marginTop: 8,
    },
    lines: {
        position: 'absolute',
        zIndex: 0,
        borderBottom: `2px solid ${lib_palette_1.default.LavendarGrey.main}`,
        width: 50,
        height: 49,
        top: -24,
    },
    linemask: {
        position: 'absolute',
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        bottom: 0,
        left: -2,
        height: 23,
        width: 10,
        zIndex: 1,
    },
    expander: {
        position: 'relative',
        width: 36,
        height: 48,
    },
    buttons: {
        maxWidth: 88,
        minWidth: 88,
        width: 88,
    },
    hoverable: {
        '& .hideIfNotOver': {
            opacity: 0,
            transition: 'opacity 0.3s',
        },
        '&:hover .hideIfNotOver': {
            opacity: 1,
        },
    },
    childlists: {
        position: 'relative',
        marginLeft: 24,
        borderLeft: `2px solid ${lib_palette_1.default.LavendarGrey.main}`,
    },
});
exports.QuestionTreeNode = react_1.default.memo((props) => {
    const { questionId } = props;
    const db = (0, useFedDB_1.default)();
    const question = db.questions[questionId];
    const [showButtons, setShowButtons] = (0, react_1.useState)(false);
    const timeoutHandle = (0, react_1.useRef)();
    const ancestors = (0, getQuestionAncestors_1.getQuestionAncestors)(db, question);
    const isAQSet = !!(question === null || question === void 0 ? void 0 : question.parentQSetId);
    const isInAQSet = ancestors === null || ancestors === void 0 ? void 0 : ancestors.some(a => !!(a === null || a === void 0 ? void 0 : a.parentQSetId));
    const { realSelf } = (0, react_1.useContext)(SelfContext_1.default);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        timeoutHandle.current = setTimeout(() => {
            setShowButtons(true);
            timeoutHandle.current = undefined;
        }, 50);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        if (timeoutHandle.current)
            clearTimeout(timeoutHandle.current);
        if (showButtons)
            setShowButtons(false);
    }, [showButtons]);
    return (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (!question)
            return null;
        const hasChildLists = !!((_a = question.childListIds) === null || _a === void 0 ? void 0 : _a.length);
        const parentList = db.lists[question.parentListId];
        const isChild = !!parentList.parentQId;
        const richInfo = question.config[question.type].richInfo;
        const isMissingQuillStr = realSelf.isSuperUser &&
            ((_b = richInfo === null || richInfo === void 0 ? void 0 : richInfo.html) === null || _b === void 0 ? void 0 : _b.length) &&
            (!(richInfo === null || richInfo === void 0 ? void 0 : richInfo.quillDeltaStr) || richInfo.quillDeltaStr === '[]');
        return (react_1.default.createElement("div", { className: myCss.root },
            react_1.default.createElement(Horizontal_1.default, { key: question.qId },
                react_1.default.createElement(Pane_1.default, { classes: { root: myCss.expander } },
                    !!isChild && react_1.default.createElement("div", { className: myCss.lines + ' hideInDrag hideInGhost' }),
                    !!hasChildLists && react_1.default.createElement(QuestionTreeNodeExpander_1.default, { question: question })),
                react_1.default.createElement(Vertical_1.default, null,
                    react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.hoverable }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
                        react_1.default.createElement(QuestionTreeNodeBox_1.default, { disabled: isAQSet || isInAQSet, question: question },
                            react_1.default.createElement(QuestionTreeNodeType_1.default, { disabled: isAQSet || isInAQSet, question: question }),
                            react_1.default.createElement(QuestionTreeNodeTitle_1.default, { disabled: isAQSet || isInAQSet, question: question }),
                            !!isMissingQuillStr && react_1.default.createElement(DotIcon_1.default, { color: lib_palette_1.default.HelixNotificationBold })),
                        react_1.default.createElement(Pane_1.default, { classes: { root: myCss.buttons } }, !!showButtons && (react_1.default.createElement(QuestionTreeNodeButtons_1.default, { hideAdd: isInAQSet, hideDrag: isInAQSet, hideDelete: isInAQSet, question: question })))),
                    !!hasChildLists && (react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.childlists + ' hideInDrag' } },
                        react_1.default.createElement("div", { className: myCss.linemask }), (_c = question.childListIds) === null || _c === void 0 ? void 0 :
                        _c.map(lid => (react_1.default.createElement(QuestionTreeList_1.default, { key: 'FormTreeList' + lid, disabled: isAQSet || isInAQSet, listId: lid })))))))));
    }, [
        question,
        db,
        realSelf,
        myCss,
        handleMouseEnter,
        handleMouseLeave,
        isAQSet,
        isInAQSet,
        showButtons,
    ]);
});
exports.default = exports.QuestionTreeNode;
